<template>
  <v-card class="cart" outlined :disabled="disabled" v-intersect="onIntersect">
    <v-card-title class="pb-0">
      <h3 class="heading font-weight-bold"
        >Cart
        <transition name="fade">
          <span v-if="hasRealItemsInCart" class="text-h6"
            >({{ totalQuantity }})</span
          >
        </transition></h3
      >
    </v-card-title>
    <v-card-text>
      <TimeSelect />
      <v-divider class="mb-2" />
      <transition name="fade" mode="out-in">
        <v-alert
          v-if="!hasRealItemsInCart"
          key="add-some-friggin-items"
          :type="getEmphasizeCartErrors ? 'error' : 'info'"
          text
          class="pa-2 mb-0"
          >{{
            getEmphasizeCartErrors
              ? 'You must add items to your cart to checkout.'
              : 'Please add some items to your cart.'
          }}</v-alert
        >
        <transition-group name="fade" v-else>
          <WithCartItem
            :id="cartItem.id"
            v-for="cartItem of realCartItems"
            :key="cartItem.id"
            v-slot="{ theCartItem }"
          >
            <CartItem
              :cart-item="theCartItem"
              v-if="theCartItem"
              :key="cartItem.id"
            />
          </WithCartItem>
        </transition-group>
      </transition>

      <CartTipField />

      <v-row v-if="cartSubtotal || getTipFromCart" dense>
        <v-col cols="12" class="text-sm-right">
          <v-divider class="my-1"></v-divider>
          <h3 v-if="cartSubtotal" class="text-body-1"
            >Subtotal : {{ formatUSD(getTheCart.subtotal) }}</h3
          >

          <CartFamilyDiscount />
          <CartSalesTax />
          <CartDeliveryFee />
          <CartServiceFee />
          <CartTipLineItem />

          <h2 class="font-weight-black text-h6"
            >Total : {{ formatUSD(getTheCart.total) }}</h2
          >
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Cart from '@/models/CartModel'
import TimeSelect from '@/components/TimeSelect'
import CartItem from '@/components/CartItem'
import CartFamilyDiscount from '@/components/CartFamilyDiscount'
import CartSalesTax from '@/components/CartSalesTax'
import CartDeliveryFee from '@/components/CartDeliveryFee'
import CartServiceFee from '@/components/CartServiceFee'
import CartTipLineItem from '@/components/CartTipLineItem'
import CartTipField from '@/components/CartTipField'
import WithCartItem from '@/components/DataProviders/WithCartItem'
import formatUSD from '@/utils/formatUSD'

export default {
  name: 'Cart',
  components: {
    TimeSelect,
    CartItem,
    CartFamilyDiscount,
    CartSalesTax,
    CartDeliveryFee,
    CartServiceFee,
    CartTipLineItem,
    CartTipField,
    WithCartItem,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', [
      'getTheCart',
      'hasItemsInCart',
      'hasRealItemsInCart',
      'realCartItems',
      'getTipFromCart',
      'cartSubtotal',
      'cartTotal',
      'isDelivery',
      'getEmphasizeCartErrors',
    ]),
    cart() {
      return Cart.query()
        .with('cartItems.item')
        .first()
    },

    totalQuantity() {
      let total = 0
      Object.keys(this.realCartItems).map((id) => {
        total += Number(this.realCartItems[id].quantity)
      })
      return total
    }, // totalQuantity
  },
  methods: {
    ...mapActions('cart', ['removeCartItem', 'setCartOnScreen']),

    onIntersect(entries) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      let isIntersecting = entries[0].isIntersecting
      this.setCartOnScreen(isIntersecting)
    }, // onIntersect
    formatUSD,
  },
}
</script>
